(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ls-blog-categories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var cats = document.querySelector('[data-ls-blog-cats]');
    var feed = document.querySelector('[data-ls-blog-feed]');
    if (!cats || !feed || feed.dataset.filterBound === 'true') return;
    feed.dataset.filterBound = 'true';

    var perPage = parseInt(feed.getAttribute('data-per-page'), 10) || 6;
    var activeCategories = {};
    var searchQuery = '';
    var page = 1;
    var buttons = cats.querySelectorAll('[data-blog-category]');
    var pagination = feed.querySelector('[data-blog-js-pagination]');
    var serverPagination = feed.querySelector('[data-blog-server-pagination]');
    var emptyEl = feed.querySelector('[data-blog-empty]');
    var clearBtns = feed.querySelectorAll('[data-blog-filter-clear]');
    var searchForm = cats.querySelector('[data-blog-search]');
    var searchInput = cats.querySelector('[data-blog-search-input]');
    var editorsPick =
      document.querySelector('.ls-blog-pick-section') ||
      document.getElementById('ls-blog-editors-pick');

    if (serverPagination) serverPagination.hidden = true;

    function cards() {
      return Array.prototype.slice.call(feed.querySelectorAll('[data-blog-card]'));
    }

    function hasActiveCategories() {
      for (var key in activeCategories) {
        if (activeCategories[key]) return true;
      }
      return false;
    }

    function hasActiveFilters() {
      return hasActiveCategories() || searchQuery !== '';
    }

    function matchesSearch(card) {
      if (!searchQuery) return true;
      var hay = card.getAttribute('data-search') || '';
      var terms = searchQuery.split(/\s+/);
      for (var i = 0; i < terms.length; i++) {
        if (terms[i] && hay.indexOf(terms[i]) === -1) return false;
      }
      return true;
    }

    function matchesCategories(card) {
      if (!hasActiveCategories()) return true;
      var cardCats = (card.getAttribute('data-categories') || '').split(/\s+/);
      for (var i = 0; i < cardCats.length; i++) {
        if (cardCats[i] && activeCategories[cardCats[i]]) return true;
      }
      return false;
    }

    function matching() {
      return cards().filter(function (card) {
        return matchesCategories(card) && matchesSearch(card);
      });
    }

    function setPressed() {
      Array.prototype.forEach.call(buttons, function (btn) {
        var on = !!activeCategories[btn.getAttribute('data-blog-category')];
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function applySearch(value) {
      var trimmed = (value || '').trim().toLowerCase();
      // Only filter once the query is meaningful (4+ chars); shorter input clears search filter
      searchQuery = trimmed.length >= 4 ? trimmed : '';
      page = 1;
      render();
    }

    function renderPagination(totalPages) {
      if (!pagination) return;
      pagination.innerHTML = '';
      if (totalPages <= 1) {
        pagination.hidden = true;
        return;
      }
      pagination.hidden = false;

      function pageBtn(direction, target, disabled) {
        var el = document.createElement(disabled ? 'span' : 'button');
        el.className = 'ls-blog-feed__page-btn' + (disabled ? ' is-disabled' : '');
        if (!disabled) el.type = 'button';

        var icon = document.createElement('img');
        icon.className = 'ls-blog-feed__page-chevron';
        icon.width = 12;
        icon.height = 12;
        icon.alt = '';
        icon.decoding = 'async';

        var label = document.createElement('span');

        if (direction === 'prev') {
          icon.src = feed.getAttribute('data-prev-icon') || '';
          label.textContent = 'Prev';
          el.appendChild(icon);
          el.appendChild(label);
        } else {
          icon.src = feed.getAttribute('data-next-icon') || '';
          label.textContent = 'Next';
          el.appendChild(label);
          el.appendChild(icon);
        }

        if (!disabled) {
          el.addEventListener('click', function () {
            page = target;
            render();
            feed.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
        return el;
      }

      function numBtn(n) {
        var el = document.createElement(n === page ? 'span' : 'button');
        el.className = 'ls-blog-feed__page-num' + (n === page ? ' is-current' : '');
        el.textContent = String(n);
        if (n === page) {
          el.setAttribute('aria-current', 'page');
        } else {
          el.type = 'button';
          el.addEventListener('click', function () {
            page = n;
            render();
            feed.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
        return el;
      }

      pagination.appendChild(pageBtn('prev', page - 1, page <= 1));

      var list = document.createElement('ul');
      list.className = 'ls-blog-feed__pages';
      list.setAttribute('role', 'list');

      var pages = [];
      if (totalPages <= 5) {
        for (var i = 1; i <= totalPages; i++) pages.push(i);
      } else {
        pages = [1];
        if (page > 3) pages.push('…');
        var start = Math.max(2, page - 1);
        var end = Math.min(totalPages - 1, page + 1);
        for (var p = start; p <= end; p++) pages.push(p);
        if (page < totalPages - 2) pages.push('…');
        pages.push(totalPages);
      }

      pages.forEach(function (item) {
        var li = document.createElement('li');
        if (item === '…') {
          var dots = document.createElement('span');
          dots.className = 'ls-blog-feed__page-num is-ellipsis';
          dots.textContent = '…';
          li.appendChild(dots);
        } else {
          li.appendChild(numBtn(item));
        }
        list.appendChild(li);
      });

      pagination.appendChild(list);
      pagination.appendChild(pageBtn('next', page + 1, page >= totalPages));
    }

    function render() {
      var all = cards();
      var match = matching();
      var totalPages = Math.max(1, Math.ceil(match.length / perPage));
      if (page > totalPages) page = totalPages;
      var start = (page - 1) * perPage;
      var visible = match.slice(start, start + perPage);
      var visibleSet = {};
      visible.forEach(function (card) {
        visibleSet[card.getAttribute('data-card-id')] = true;
      });

      all.forEach(function (card) {
        var id = card.getAttribute('data-card-id');
        card.hidden = !visibleSet[id];
      });

      if (emptyEl) {
        emptyEl.hidden = match.length > 0;
      }

      if (editorsPick) {
        editorsPick.hidden = hasActiveFilters();
      }

      renderPagination(match.length ? totalPages : 0);
      setPressed();
    }

    function loadRemainingArticles() {
      var metaEl = feed.querySelector('[data-blog-load-more]');
      var grid = feed.querySelector('.ls-blog-feed__grid');
      if (!metaEl || !grid) return Promise.resolve();

      var meta;
      try {
        meta = JSON.parse(metaEl.textContent);
      } catch (err) {
        return Promise.resolve();
      }

      var totalPages = parseInt(meta.pages, 10) || 1;
      if (totalPages <= 1 || !meta.url) return Promise.resolve();

      var view = meta.view || 'card-feed';
      var requests = [];

      for (var p = 2; p <= totalPages; p++) {
        (function (pageNum) {
          var joiner = meta.url.indexOf('?') === -1 ? '?' : '&';
          var url = meta.url + joiner + 'view=' + encodeURIComponent(view) + '&page=' + pageNum;
          requests.push(
            fetch(url)
              .then(function (res) {
                if (!res.ok) throw new Error('Failed to load articles page ' + pageNum);
                return res.text();
              })
              .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var nodes = doc.querySelectorAll('[data-blog-card]');
                var frag = document.createDocumentFragment();
                Array.prototype.forEach.call(nodes, function (node) {
                  frag.appendChild(document.importNode(node, true));
                });
                return { page: pageNum, frag: frag };
              })
          );
        })(p);
      }

      return Promise.all(requests)
        .then(function (results) {
          results.sort(function (a, b) {
            return a.page - b.page;
          });
          results.forEach(function (result) {
            grid.appendChild(result.frag);
          });
        })
        .catch(function () {
          /* Keep the first 50 if extra pages fail to load */
        });
    }

    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener('click', function () {
        var next = btn.getAttribute('data-blog-category') || '';
        if (!next) return;
        if (activeCategories[next]) {
          delete activeCategories[next];
        } else {
          activeCategories[next] = true;
        }
        page = 1;
        render();
      });
    });

    Array.prototype.forEach.call(clearBtns, function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        activeCategories = {};
        searchQuery = '';
        if (searchInput) searchInput.value = '';
        page = 1;
        render();
      });
    });

    if (searchForm) {
      searchForm.addEventListener('submit', function (event) {
        event.preventDefault();
        applySearch(searchInput ? searchInput.value : '');
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        applySearch(searchInput.value);
      });
    }

    render();
    loadRemainingArticles().then(function () {
      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false,
        {
          infinite: false,
          slidesToShow: 1.4,
          slidesToScroll: 1,
          swipeToSlide: true,
          dots: false,
          arrows: false
        }
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
